/*
 * @forgerock/javascript-sdk
 *
 * constants.ts
 *
 * Copyright (c) 2020 ForgeRock. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
/**
 * @module
 * @ignore
 * These are private constants for TokenStorage
 */
var DB_NAME = 'forgerock-sdk';
/** @hidden */
var TOKEN_KEY = 'tokens';
export { DB_NAME, TOKEN_KEY };
//# sourceMappingURL=constants.js.map